{
  "REACT_APP_LOG_LEVEL": "logLevel",
  "REACT_APP_API_SITE": "apiSite",
  "REACT_APP_USE_MOCK_ADAPTER": "useMockAdapter",
  "REACT_APP_RENDER_ERRORS": "renderErrors",
  "REACT_APP_DISABLE_MOBILE_SITE_WARNING": "disableMobileSiteWarning",
  "REACT_APP_APP_VERSION": "appVersion"
}
